module.exports = __webpack_public_path__ + "img/logo.bf18cbeb.png";